/* CR46 sticky buy bar — vanilla, no library, no third-party script.
   Shows a fixed bottom bar once the main Add to Cart scrolls out of view.
   Mirrors size selection both ways and submits the SAME product form. */
(function () {
  'use strict';
  var bar = document.querySelector('[data-cr46-sticky]');
  if (!bar || !('IntersectionObserver' in window)) return;

  var formId = bar.getAttribute('data-form-id');
  var mainBtn = document.getElementById(bar.getAttribute('data-main-button-id'));
  var form = document.getElementById(formId);
  if (!mainBtn || !form) return;

  var sizeOut = bar.querySelector('[data-cr46-size]');
  var stickyBtn = bar.querySelector('[data-cr46-submit]');
  var SIZE_RE = /^(size|talla|taille)$/i;

  function currentSize() {
    var checked = form.querySelectorAll('fieldset input[type="radio"]:checked');
    for (var i = 0; i < checked.length; i++) {
      var fs = checked[i].closest('fieldset');
      var legend = fs && fs.querySelector('legend');
      var label = legend ? legend.textContent.replace(/\s+/g, ' ').trim() : '';
      if (SIZE_RE.test(label.split(/\s/)[0] || '')) return checked[i].value;
    }
    return checked.length ? checked[checked.length - 1].value : '';
  }

  function syncSize() {
    if (!sizeOut) return;
    var v = currentSize();
    sizeOut.textContent = v || sizeOut.getAttribute('data-empty') || '';
    sizeOut.hidden = !v;
  }

  function syncDisabled() {
    if (!stickyBtn) return;
    stickyBtn.disabled = !!mainBtn.disabled;
  }

  // Size changes flow bar <- form. The bar has no own inputs, so the "both ways"
  // requirement is met by the bar submitting the real form: one source of truth.
  form.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') { syncSize(); syncDisabled(); }
  });

  if (stickyBtn) {
    // RS4-WEB (W3): a shopper who never chose a size should not add the pre-selected one by accident.
    // Until a size is chosen, the bar takes them to the size buttons instead. (The tested winner is a
    // slide-up size drawer, GrowthRock +5.2% orders; this is the smallest step toward it.)
    var chosen = false;
    form.addEventListener('change', function (e) { if (e.target && e.target.type === 'radio') chosen = true; });
    stickyBtn.addEventListener('click', function () {
      var sets = form.querySelectorAll('fieldset'), picker = null;
      for (var i = 0; i < sets.length && !picker; i++) {
        var lg = sets[i].querySelector('legend');
        if (lg && SIZE_RE.test((lg.textContent.replace(/\s+/g, ' ').trim().split(/\s/)[0]) || '')) picker = sets[i];
      }
      picker = picker || sets[0];
      if (!chosen && picker) {
        picker.scrollIntoView({ behavior: 'smooth', block: 'center' });
        picker.classList.add('nm-pick-size');
        setTimeout(function () { picker.classList.remove('nm-pick-size'); }, 1600);
        var first = picker.querySelector('input:not([disabled]) + label, input:not([disabled])');
        if (first && first.focus) first.focus({ preventScroll: true });
        return;
      }
      // Click the real button so the theme's product-form handler runs unchanged.
      mainBtn.click();
    });
  }

  var shown = false;
  function show(on) {
    if (on === shown) return;
    shown = on;
    bar.classList.toggle('cr46-sticky--visible', on);
    bar.setAttribute('aria-hidden', on ? 'false' : 'true');
    // CR47: let floating widgets (chat) move clear of the bar while it is on screen.
    document.body.classList.toggle('nm-sticky-on', on);
    // Keyboard reachability follows visibility so the hidden bar never traps focus.
    if (stickyBtn) stickyBtn.tabIndex = on ? 0 : -1;
  }

  new IntersectionObserver(function (entries) {
    show(!entries[0].isIntersecting);
  }, { rootMargin: '0px 0px -8px 0px', threshold: 0 }).observe(mainBtn);

  // Never cover the element a keyboard user just focused.
  document.addEventListener('focusin', function (e) {
    if (!shown || bar.contains(e.target)) return;
    var r = e.target.getBoundingClientRect ? e.target.getBoundingClientRect() : null;
    if (r && r.bottom > window.innerHeight - bar.offsetHeight) show(false);
  });

  syncSize(); syncDisabled();
  var mo = new MutationObserver(syncDisabled);
  mo.observe(mainBtn, { attributes: true, attributeFilter: ['disabled'] });
})();
